import { AppLanguageOptionsSubsetEnum } from "../../app/models/constants/app-language-options.const";

// Currently we do not need many customer specific overrides
// if those become more complex in the future, we might want to move them to separate json files instead
export const customerOverridesByLanguage: Record<
  string,
  Record<AppLanguageOptionsSubsetEnum, Record<string, unknown>>
> = {
  bmb: {
    de: {
      app: {
        title: "KI-Portal",
      },
      footer: {
        impressumUrl: "https://www.bmb.gv.at/Ministerium/Impressum.html",
        contactUrl: "https://www.bmb.gv.at/Ministerium/Kontakt.html",
        privacyPolicyUrl: "https://www.bmb.gv.at/Ministerium/Informationspflicht/Datenschutz.html",
      },
      pages: {
        landingPage: {
          title: "Willkommen im",
        },
      },
    },
    en: {
      app: {
        title: "AI Portal",
      },
      footer: {
        impressumUrl: "https://www.bmb.gv.at/Ministerium/Impressum.html",
        contactUrl: "https://www.bmb.gv.at/Ministerium/Kontakt.html",
        privacyPolicyUrl: "https://www.bmb.gv.at/en/Ministry/Information/Data-protection.html",
      },
      pages: {
        landingPage: {
          title: "Welcome to the",
        },
      },
    },
    fr: {
      app: {
        title: "Portail IA",
      },
      footer: {
        impressumUrl: "https://www.bmb.gv.at/Ministerium/Impressum.html",
        contactUrl: "https://www.bmb.gv.at/Ministerium/Kontakt.html",
        privacyPolicyUrl: "https://www.bmb.gv.at/Ministerium/Informationspflicht/Datenschutz.html",
      },
    },
  },
};
